import { Box } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../../../components/forms/form-input/FormInput";
import FormPropertySection from "../../../../components/forms/form-property-section/FormPropertySection";
import FormProperty from "../../../../components/forms/form-property/FormProperty";

export default function GeneralStep(): JSX.Element {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                paddingLeft: 2,
                paddingTop: 2
            }}
        >
            <FormPropertySection label={t("uiCustomizationPresetEditor.steps.general.presetInformation")}>
                <FormProperty>
                    <FormInput
                        ariaLabel="preset name"
                        name="name"
                        label={t("uiCustomizationPresetEditor.steps.general.name")}
                        sx={{ width: "100%" }}
                        rules={{
                            required: t("uiCustomizationPresetEditor.steps.general.nameRequired")
                        }}
                    />
                </FormProperty>
            </FormPropertySection>

            <FormPropertySection label="">
                <FormProperty>
                    <FormInput
                        ariaLabel="preset description"
                        name="description"
                        label={t("uiCustomizationPresetEditor.steps.general.description")}
                        sx={{ width: "100%" }}
                        multiline={true}
                        rows={4}
                        rules={{
                            required: t("uiCustomizationPresetEditor.steps.general.descriptionRequired")
                        }}
                    />
                </FormProperty>
            </FormPropertySection>
        </Box>
    );
}
